<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<h1 mat-dialog-title>{{ title }}</h1>
<div style="font-family: 'open_sansregular', sans-serif">{{ message }}</div>

<form [formGroup]="form" class="name-form">
  <mat-form-field class="form-full-width">
    <mat-label>Name</mat-label>
    <input
      formControlName="name"
      matInput
      placeholder="Name"
      autocomplete="off"
    />

    @if (name.invalid && (name.dirty || name.touched)) {
    <mat-error>
      @for (validator of validators; track validator) { @if
      (name.hasError(validator.name)) {
      {{ validator.errorMessage }}<br />
      } }
    </mat-error>
    }
  </mat-form-field>
</form>

<mat-dialog-actions
  class="d-flex flex-row justify-content-around align-items-center"
>
  <button
    mat-flat-button
    color="primary"
    hotkeyAction="ENTER"
    (click)="onClick()"
    [disabled]="!form.valid || !form.dirty"
    tabindex="3"
  >
    Save
  </button>
  <button mat-flat-button color="primary" (click)="onCancel()" tabindex="3">
    Cancel
  </button>
</mat-dialog-actions>
